import {ALIGNMENT_TYPE} from '@Components/dropdown-v2/dropdown.types';
import type {EditorViewport} from '@EmailMakerReact/email-maker-react.types';
import type {Editor} from 'grapesjs';

export interface PublishingOptionsMenuProps {
  editorViewport: EditorViewport;
  editor: Editor | null;
}

export const ICON_MORE_HORIZONTAL = 'icon-more-h';

/** BOTTOM_END so the dropdown opens down-and-left, staying inside the nav's right edge. */
export const PUBLISHING_OPTIONS_DROPDOWN_ALIGNMENT = ALIGNMENT_TYPE.BOTTOM_END;
